module.exports = __webpack_public_path__ + "static/media/person116.6f98f0ce.ico";